<template>
  <div class="relative flex flex-wrap gap-8">
    <div v-for="optionGroup in getOptionGroups" :key="optionGroup.id">
      <h3 class="text-xs font-medium uppercase">
        <!-- If the optionGroup does not have a name in shopware (German translation) we get a nasty bug and the variant switching doesn't work -->
        {{ optionGroup.name }}
      </h3>
      <fieldset class="mt-2 flex-1">
        <legend class="sr-only">
          {{ optionGroup.name }}
        </legend>
        <ShopProductVariantOptions
          :key="optionGroup.id"
          :group="optionGroup"
          @change="
            (id: string) => handleChange(optionGroup.name, id, onHandleChange)
          "
        />
      </fieldset>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = withDefaults(
  defineProps<{
    allowRedirect?: boolean
  }>(),
  {
    allowRedirect: true,
  }
)

const emit = defineEmits<{
  (e: 'change', selected: Schemas['Product']): void
}>()

const { getProductRoute } = useShopRouter()

const isLoading = ref<boolean>()
const router = useRouter()
const {
  handleChange,
  getOptionGroups,
  getSelectedOptions,
  findVariantForSelectedOptions,
} = useProductConfigurator()

const onHandleChange = async () => {
  isLoading.value = true

  let options = getSelectedOptions.value

  const notCombinable: { [key: string]: string } = {}

  // find all options that are not combinable
  for (const [key, optionId] of Object.entries(options)) {
    const option = getOptionGroups.value
      .flatMap((group) => group.options)
      .find((option) => option.id === optionId)
    if (option?.customFields?.combinable === false) {
      notCombinable[key] = optionId
    }
  }

  // if there are no combinable options, we keep only them and remove the rest
  // the backend will then redirect to the correct variant
  if (Object.keys(notCombinable).length) {
    options = notCombinable
  }

  const variantFound = await findVariantForSelectedOptions(options)
  if (!variantFound) {
    console.error('No variant found for selected options')
    return
  }
  const selectedOptionsVariantPath = getProductRoute(variantFound)
  if (props.allowRedirect && selectedOptionsVariantPath) {
    try {
      await router.push(selectedOptionsVariantPath)
    } catch (error) {
      console.error('incorrect URL', selectedOptionsVariantPath)
    }
  } else if (variantFound) emit('change', variantFound)
  isLoading.value = false
}
</script>
